const STORAGE_KEY = 'mo-ferramenta-states'
const USAGE_KEY = 'mo-ferramenta-used'

type FerramentaStates = Record<string, Record<string, unknown>>
type FerramentaUsage = Record<string, string>

function readAll(): FerramentaStates {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as FerramentaStates) : {}
  } catch {
    return {}
  }
}

function writeAll(data: FerramentaStates) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  window.dispatchEvent(new CustomEvent('mo-ferramenta-change'))
}

export function getFerramentaState<T extends Record<string, unknown>>(toolId: string): T | null {
  const all = readAll()
  return (all[toolId] as T) ?? null
}

export function saveFerramentaState(toolId: string, state: Record<string, unknown>) {
  const all = readAll()
  all[toolId] = { ...state, _savedAt: new Date().toISOString() }
  writeAll(all)
}

export function clearFerramentaState(toolId: string) {
  const all = readAll()
  delete all[toolId]
  writeAll(all)
}

function readUsage(): FerramentaUsage {
  try {
    const raw = localStorage.getItem(USAGE_KEY)
    return raw ? (JSON.parse(raw) as FerramentaUsage) : {}
  } catch {
    return {}
  }
}

function writeUsage(data: FerramentaUsage) {
  localStorage.setItem(USAGE_KEY, JSON.stringify(data))
}

export function markFerramentaUtilizada(toolId: string) {
  if (!toolId) return
  const all = readUsage()
  if (all[toolId]) return
  all[toolId] = new Date().toISOString()
  writeUsage(all)
}

function hasMeaningfulState(state: Record<string, unknown>): boolean {
  return Object.entries(state).some(([key, value]) => {
    if (key === '_savedAt') return false
    if (value == null || value === '') return false
    if (Array.isArray(value) && value.length === 0) return false
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
      return false
    }
    return true
  })
}

export function isFerramentaUtilizada(toolId: string): boolean {
  if (!toolId) return false
  if (readUsage()[toolId]) return true
  const state = getFerramentaState(toolId)
  return state != null && hasMeaningfulState(state)
}
